import { BinaryTreeLogo } from '@/frontend/design-system/_marketing/logos/BinaryTreeLogo'
import { OIJLogo } from '@/frontend/design-system/_marketing/logos/OIJLogo'
import { OILogo } from '@/frontend/design-system/_marketing/logos/OILogo'
import { JavaScriptLogo } from '@/frontend/design-system/svg/logos'

export type Course = {
  name: string
  description: string
  href: string
  icon: React.ReactNode
}

export const elementarySchoolCourses: Course[] = [
  {
    name: 'Olimpiada Informatyczna Juniorów',
    description: 'Zostań finalistą Olimpiady Informatycznej Juniorów',
    href: `/kursy/olimpiada-informatyczna-juniorow`,
    icon: <OIJLogo />
  },
  {
    name: 'Podstawy Programowania',
    description: 'Naucz się myśleć jak programista i tworzyć własne aplikacje',
    href: `/kursy/podstawy-programowania`,
    icon: <JavaScriptLogo size={24} />
  }
]

export const highSchoolCourses: Course[] = [
  {
    name: 'Olimpiada Informatyczna',
    description: 'Zostań finalistą Olimpiady Informatycznej',
    href: `/kursy/olimpiada-informatyczna`,
    icon: <OILogo />
  }
  // {
  //   name: 'Matematyka dla informatyków',
  //   description: 'Idealny dla programów, gdzie szybkość ma znaczenie',
  //   href: `/kursy/${encodeURIComponent('Matematyka dla informatyków')}`,
  //   icon: <OSILogo />
  // }
]

export const universityCourses: Course[] = [
  {
    name: 'Przygotuj się do job interview',
    description: 'Zdobądź wymarzoną pracę w branży IT',
    href: `/kursy/przygotuj-sie-do-job-interview`,
    icon: <BinaryTreeLogo />
  }
]

export const aboutLinks = [
  {
    name: 'O nas',
    href: '/o-nas'
  },
  {
    name: 'Aktualności',
    href: '/aktualnosci'
  },
  {
    name: 'Nasza metoda nauczania',
    href: '/nasza-metoda-nauczania'
  },
  {
    name: 'Nasi partnerzy',
    href: '/partnerzy'
  },
  {
    name: 'Program stypendialny',
    href: '/stypendium'
  },
  {
    name: 'Najczęściej zadawane pytania',
    href: '/faq'
  }
]

export const mentoringLinks = [
  {
    name: 'Oferta',
    href: '/mentoring'
  },
  {
    name: 'Czym jest mentoring?',
    href: '/czym-jest-mentoring'
  },
  {
    name: 'Umów spotkanie',
    href: '/bezplatna-konsultacja'
  }
]

export const manageSiteLinks = [
  {
    name: 'Portfolio nauczycieli',
    href: '/portfolia'
  },
  {
    name: 'Technologie i umiejętności',
    href: '/technologie/zarzadzaj'
  }
]
